import React from "react";

export default function WhatsAppButton() {
  const onClick = () => {
    window.open("https://wa.me/56975359774?text=" + encodeURIComponent("Hola, quiero personalizar una funda"), "_blank");
  };
  return (
    <button
      onClick={onClick}
      data-testid="floating-whatsapp"
      className="fixed bottom-5 left-5 z-40 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white flex items-center justify-center shadow-lg transition animate-float-soft"
      aria-label="WhatsApp"
    >
      <i className="fa-brands fa-whatsapp text-2xl" />
    </button>
  );
}
